export default "<div class=\"blank-container\">\r\n  <ng-content></ng-content>\r\n</div>\r\n";